import { Connection } from '../utils/ws-connection';
import { observable } from 'mobx';
import logger from '../utils/logger';
import RootStore from './root-store';

const ConnectionState = {
  Connected: 'Connected',
  Connecting: 'Connecting',
  Disconnected: 'Disconnected',
};

class WebsocketStore {
  rootStore: RootStore;
  timer: ReturnType<typeof setTimeout> | undefined;
  @observable connection: Connection | null = null;
  @observable connected: boolean = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  get isTrulyConnected() {
    return this.connected && this.connection?.connection?.state === ConnectionState.Connected;
  }

  async connect() {
    const { connectionStore, newAuthStore, locationsStore } = this.rootStore;

    if (!connectionStore.isOnline || !newAuthStore.isAuthenticated || !locationsStore.divisionCode) {
      return Promise.reject(new Error('Waiting for websocket connection'));
    }

    if (!newAuthStore.authToken || newAuthStore.tokenExpired) {
      return Promise.reject(new Error('Websocket can\'t connect, no token set or token expired'));
    }

    this.connection = new Connection({
      token: newAuthStore.authToken,
      plantId: locationsStore.plantId,
      url: newAuthStore.companyConfig.apiServer,
      scope: locationsStore.divisionCode,
    });

    this.connection.onclose((e: any): void => {
      logger.warn('websocket disconnected', e);
      this.onClose();
    });

    try {
      await this.connection.start();
      logger.log('websocket start!');
      this.connected = true;
      return this.connection;
    } catch (e) {
      logger.warn('Fail to start websocket!!', e);
      this.onClose();
    }
  }

  onClose() {
    this.connected = false;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.connect().catch(e => {
        logger.warn(e.message);
        this.onClose();
      });
    }, 1000);
  };
}

export default WebsocketStore;
